import { defineMessages } from 'react-intl';

export const onboardingMessages = defineMessages({
    'onboarding.stepper': {
        id: 'onboarding.stepper',
        defaultMessage:
            'Onboarding survey stepper. The current step is {currentStep}',
        description:
            'Alt text for the onboarding survey tracking what step the user is currently viewing.',
    },
    'onboarding.goals.background_video': {
        id: 'onboarding.goals.background_video',
        defaultMessage: 'A calming light blue visualizer',
        description:
            'Alt text for the background video on the goals onboarding step.',
    },
    'onboarding.goals.title': {
        id: 'onboarding.goals.title',
        defaultMessage: 'Your Goals',
        description: 'Title for the goals onboarding step.',
    },
    'onboarding.goals.info_video': {
        id: 'onboarding.goals.info_video',
        defaultMessage: 'Play a video to learn more about goals',
        description: 'Alt text for the video on the goals onboarding step.',
    },
    'onboarding.goals.poll_subtitle': {
        id: 'onboarding.goals.poll_subtitle',
        defaultMessage: 'Select your goals',
        description: 'Prompt for the user to select their goals.',
    },
    'onboarding.topics.background_video': {
        id: 'onboarding.topics.background_video',
        defaultMessage: 'A calming light purple visualizer',
        description:
            'Alt text for the background video on the topics onboarding step.',
    },
    'onboarding.topics.title': {
        id: 'onboarding.topics.title',
        defaultMessage: 'Your Topics',
        description: 'Title for the topics onboarding step.',
    },
    'onboarding.topics.info_video': {
        id: 'onboarding.topics.info_video',
        defaultMessage: 'Play a video to learn more about topics',
        description: 'Alt text for the video on the topics onboarding step.',
    },
    'onboarding.topics.poll_subtitle': {
        id: 'onboarding.topics.poll_subtitle',
        defaultMessage: 'Select up to {maxOptions}',
        description:
            'Prompt for the user to select the topics they are interested in.',
    },
    'onboarding.conditions.title': {
        id: 'onboarding.conditions.title',
        defaultMessage: 'Your Mental and Physical Health Conditions',
        description: 'Title for the conditions onboarding step.',
    },
    'onboarding.conditions.added': {
        id: 'onboarding.conditions.added',
        defaultMessage: 'Conditions Added',
        description:
            'Heading text to display when the user has added conditions.',
    },
    'onboarding.conditions.empty_title': {
        id: 'onboarding.conditions.empty_title',
        defaultMessage: 'Add your mental and physical health conditions',
        description:
            'Prompt for the user to add their mental and physical health conditions.',
    },
    'onboarding.conditions.mental_and_physical_conditions': {
        id: 'onboarding.conditions.mental_and_physical_conditions',
        defaultMessage: 'Mental and Physical Health Conditions',
        description: 'Subtitle for the conditions onboarding step.',
    },
    'onboarding.conditions.mental_and_physical_conditions_description': {
        id: 'onboarding.conditions.mental_and_physical_conditions_description',
        defaultMessage:
            "Emotional and physical health are intimately intertwined in what's known as the mind-body connection.",
        description:
            'Description of the relationship between mental and physical health.',
    },
    'onboarding.conditions.info_video': {
        id: 'onboarding.conditions.info_video',
        defaultMessage: 'Play a video to learn more about conditions',
        description:
            'Alt text for the video on the conditions onboarding step.',
    },
    'onboarding.conditions.add': {
        id: 'onboarding.conditions.add',
        defaultMessage: 'Add Condition',
        description: 'Button text to add a condition.',
    },
    'onboarding.conditions.background_video': {
        id: 'onboarding.conditions.background_video',
        defaultMessage: 'A calming light blue, purple and white visualizer',
        description:
            'Alt text for the background video on the conditions onboarding step.',
    },
    'onboarding.conditions.filter_conditions': {
        id: 'onboarding.conditions.filter_conditions',
        defaultMessage: 'Filter Conditions',
        description: 'Button text to filter the conditions.',
    },
    'onboarding.conditions.clear_search': {
        id: 'onboarding.conditions.clear_search',
        defaultMessage: 'Clear search',
        description: 'Button text to clear the conditions search input box.',
    },
    'onboarding.conditions.select_condition': {
        id: 'onboarding.conditions.select_condition',
        defaultMessage: 'Select a Condition to Add',
        description: 'Prompt for the user to select a condition to add.',
    },
    'onboarding.conditions.already_added': {
        id: 'onboarding.conditions.already_added',
        defaultMessage: 'Condition already added',
        description:
            'Text to display if a user has already added a condition and tries to do it again.',
    },
    'onboarding.conditions.has_already_added': {
        id: 'onboarding.conditions.has_already_added',
        defaultMessage: '{name} has already been added',
        description:
            'Text to display if a user has already added a condition and tries to do it again.',
    },
    'onboarding.conditions.delete_confirm': {
        id: 'onboarding.conditions.delete_confirm',
        defaultMessage: 'Are you sure you want to delete {name}?',
        description:
            'Confirmation prompt when a user tries to delete a condition.',
    },
    'onboarding.conditions.delete_confirm_description': {
        id: 'onboarding.conditions.delete_confirm_description',
        defaultMessage: 'Deleting it will remove it from all instances.',
        description:
            'Explanation of what will happen if the user deletes a condition.',
    },
    'onboarding.conditions.no_matching': {
        id: 'onboarding.conditions.no_matching',
        defaultMessage: 'No Matching Conditions',
        description: 'Text to display if filtering option returns no results.',
    },
    'onboarding.conditions.no_matching_description': {
        id: 'onboarding.conditions.no_matching_description',
        defaultMessage: 'No matching conditions found based on your search.',
        description: 'Text to display if filtering option returns no results.',
    },
    'onboarding.conditions.results_count': {
        id: 'onboarding.conditions.results_count',
        defaultMessage:
            '{count, plural, one {# condition available} other {# conditions available}}',
        description:
            'Screen-reader-only status announcement of how many conditions match the current filter search.',
    },
    'onboarding.conditions.condition_removed': {
        id: 'onboarding.conditions.condition_removed',
        defaultMessage: '{name} removed',
        description:
            'Screen-reader-only status announcement made when a condition chip is dismissed from the selected conditions list.',
    },
    'onboarding.conditions.saved': {
        id: 'onboarding.conditions.saved',
        defaultMessage: 'Condition Saved',
        description: 'Text to display when a condition has been saved.',
    },
    'onboarding.conditions.deleted': {
        id: 'onboarding.conditions.deleted',
        defaultMessage: 'Condition Deleted',
        description: 'Text to display when a condition has been deleted.',
    },
    'onboarding.conditions.condition_actions': {
        id: 'onboarding.conditions.condition_actions',
        defaultMessage: 'Open condition actions menu',
        description:
            'Alt text for the button that opens condition actions menu.',
    },
    'onboarding.conditions.submit.error': {
        id: 'onboarding.conditions.submit.error',
        defaultMessage:
            'There was an error saving your conditions. Please try again.',
        description:
            'Error message to display when there is an error saving the user conditions.',
    },
    'onboarding.screening.title': {
        id: 'onboarding.screening.title',
        defaultMessage: 'Your Mental Health Screening',
        description:
            'Introductory text for the mental health screening onboarding step.',
    },
    'onboarding.screening.background_video': {
        id: 'onboarding.screening.background_video',
        defaultMessage: 'A calming light purple visualizer',
        description:
            'Alt text for the background video on the mental health screening onboarding step.',
    },
    'onboarding.screening.info_video': {
        id: 'onboarding.screening.info_video',
        defaultMessage:
            'Play a video to learn more about mental health screening',
        description:
            'Alt text for the button that plays a video about the mental health screening.',
    },
    'onboarding.screening.pod': {
        id: 'onboarding.screening.pod',
        defaultMessage: 'Screening start screen pod',
        description:
            'Text for the pod that appears on the mental health screening onboarding step.',
    },
    'onboarding.screening.header': {
        id: 'onboarding.screening.header',
        defaultMessage: 'Let’s check-in on your mental health',
        description: 'Header for the mental health screening onboarding step.',
    },
    'onboarding.screening.header.ga': {
        id: 'onboarding.screening.header.ga',
        defaultMessage: 'First, let’s check-in on your mental health',
        description:
            'GA Header for the mental health screening onboarding step.',
    },
    'onboarding.screening.first_pod_title': {
        id: 'onboarding.screening.first_pod_title',
        defaultMessage: 'This quick screening will take 1-2 minutes.',
        description:
            'Description that the mental health screening will be quick.',
    },
    'onboarding.screening.first_pod_subtitle': {
        id: 'onboarding.screening.first_pod_subtitle',
        defaultMessage:
            'Your answers will help us provide better recommendations and customize your experience.',
        description:
            'Explanation of how the mental health screening will be used.',
    },
    'onboarding.screening.second_pod_title': {
        id: 'onboarding.screening.second_pod_title',
        defaultMessage: 'Achievable',
        description:
            'Title for the second pod on the mental health screening onboarding step.',
    },
    'onboarding.screening.second_pod_subtitle': {
        id: 'onboarding.screening.second_pod_subtitle',
        defaultMessage:
            'Research shows that simply keeping track of your progress makes you more aware of your goals, and more likely to accomplish them.',
        description:
            'Explanation of how the mental health screening will help the user.',
    },
    'onboarding.screening.third_pod_title': {
        id: 'onboarding.screening.third_pod_title',
        defaultMessage: 'Private and Secure',
        description:
            'Title for the third pod on the mental health screening onboarding step.',
    },
    'onboarding.screening.third_pod_subtitle': {
        id: 'onboarding.screening.third_pod_subtitle',
        defaultMessage:
            'We take your privacy very seriously and are certified to keep your personal information safe and secure.',
        description:
            "Explanation of how Calm Health will keep the user's information safe.",
    },
    'onboarding.screening.notice': {
        id: 'onboarding.screening.notice',
        defaultMessage:
            'This assessment is not a substitute for care by a physician or other health care provider.',
        description:
            'Notice that the mental health screening is not a substitute for care by a physician or other health care provider.',
    },
    'onboarding.screening.get_started': {
        id: 'onboarding.screening.get_started',
        defaultMessage: 'Get Started',
        description: 'Button text to start the mental health screening.',
    },
    'onboarding.screening.skip_dialog_title': {
        id: 'onboarding.screening.skip_dialog_title',
        defaultMessage: 'Are you sure you would like to skip the screening?',
        description:
            'Confirmation prompt when a user tries to skip the mental health screening.',
    },
    'onboarding.screening.skip_dialog_subtitle': {
        id: 'onboarding.screening.skip_dialog_subtitle',
        defaultMessage:
            'If you skip the screening, you can take it later from your Plan.',
        description:
            'Explanation of that the user skips the mental health screening now, they will still have an ability to take it later.',
    },
    'onboarding.screening.skip_retrigger_dialog_title': {
        id: 'onboarding.screening.skip_retrigger_dialog_title',
        defaultMessage:
            'Are you sure you would like to skip this month’s mental health screening?',
        description:
            'Confirmation prompt when a user tries to skip the mental health screening.',
    },
    'onboarding.screening.skip_dialog_skip_button': {
        id: 'onboarding.screening.skip_dialog_skip_button',
        defaultMessage: 'Skip Screening',
        description: 'Button text to skip the mental health screening.',
    },
    'onboarding.screening.skip_dialog_start_button': {
        id: 'onboarding.screening.skip_dialog_start_button',
        defaultMessage: 'Start Screening',
        description: 'Button text to start the mental health screening.',
    },
    'onboarding.screening.quit_dialog_title': {
        id: 'onboarding.screening.quit_dialog_title',
        defaultMessage:
            'Are you sure you would like to quit the mental health screening?',
        description:
            'Confirmation prompt when a user tries to quit the mental health screening.',
    },
    'onboarding.screening.quit_dialog_quit_button': {
        id: 'onboarding.screening.quit_dialog_quit_button',
        defaultMessage: 'Quit Screening',
        description: 'Button text to quit the mental health screening.',
    },
    'onboarding.screening.quit_dialog_continue_button': {
        id: 'onboarding.screening.quit_dialog_continue_button',
        defaultMessage: 'Continue Screening',
        description: 'Button text to continue the mental health screening.',
    },
    'onboarding.screening.progress': {
        id: 'onboarding.screening.progress',
        defaultMessage: 'Progress: {progress}%',
        description:
            'Text showing the user how far they are in the mental health screening.',
    },
    'onboarding.screening.is_complete': {
        id: 'onboarding.screening.is_complete',
        defaultMessage: 'Your mental health screening is complete.',
        description:
            'Text to display when the user has completed the mental health screening.',
    },
    'onboarding.screening.standalone.residence_question': {
        id: 'onboarding.screening.standalone.residence_question',
        defaultMessage:
            'Do you live in the United States and are you 18 or older?',
        description:
            'Residence question for the standalone mental health screening, used to determine eligibility.',
    },
    'onboarding.screening.standalone.residence_terms': {
        id: 'onboarding.screening.standalone.residence_terms',
        defaultMessage:
            "By clicking 'Continue' and taking this screening, you agree to our <link1>Terms</link1> and acknowledge that you have read our <link2>Privacy Policy</link2>",
        description:
            'Terms and conditions for the standalone mental health screening.',
    },
    'onboarding.screening.standalone.consent.title': {
        id: 'onboarding.screening.standalone.consent.title',
        defaultMessage: 'Consent to Collect Consumer Health Data',
        description:
            'Consent title for the standalone mental health screening.',
    },
    'onboarding.screening.standalone.consent.heading': {
        id: 'onboarding.screening.standalone.consent.heading',
        defaultMessage: 'Consent',
        description:
            'Heading for the consent section of the standalone mental health screening.',
    },
    'onboarding.screening.standalone.consent.i_consent': {
        id: 'onboarding.screening.standalone.consent.i_consent',
        defaultMessage: 'I Consent',
        description:
            'Button text to consent to the standalone mental health screening.',
    },
    'onboarding.screening.standalone.consent.partner_name_consent': {
        id: 'onboarding.screening.standalone.consent.partner_name_consent',
        defaultMessage: '{name} Consent',
        description:
            'Name section of the consent for the standalone mental health screening.',
    },
    'onboarding.screening.standalone.non_us_resident.title': {
        id: 'onboarding.screening.standalone.non_us_resident.title',
        defaultMessage: 'We’re sorry!',
        description:
            'Title displayed when a user who is not a U.S. resident tries to take the standalone mental health screening. Calm is unable to offer them access to the screening.',
    },
    'onboarding.screening.standalone.non_us_resident.description_1': {
        id: 'onboarding.screening.standalone.non_us_resident.description_1',
        defaultMessage:
            'At the present time, the mental health screening is available only to U.S. residents age 18 and older.',
        description:
            'Explanation of why the user cannot take the standalone mental health screening.',
    },
    'onboarding.screening.standalone.non_us_resident.description_2': {
        id: 'onboarding.screening.standalone.non_us_resident.description_2',
        defaultMessage:
            'Wherever you are in the world, you can enjoy Calm, the world’s leading app for sleep, meditation, and relaxation. We’re happy to offer you a 40% discount on your first year of Calm Premium, so you can continue your mental health journey.',
        description:
            'Promotion for the Calm app for users who are not U.S. residents.',
    },
    'onboarding.screening.standalone.non_us_resident.disclaimer': {
        id: 'onboarding.screening.standalone.non_us_resident.disclaimer',
        defaultMessage:
            'You might already have access to Calm as part of your employee benefits. Check with your employer’s HR benefits department.',
        description:
            'Prompt directing users to try to redeem a subscription to the Calm app through their employer.',
    },
    'onboarding.screening.standalone.non_us_resident.try_calm': {
        id: 'onboarding.screening.standalone.non_us_resident.try_calm',
        defaultMessage: '40% Off Calm',
        description: 'Discount offer',
    },
    'onboarding.screening.standalone.non_us_resident.try_calm_body': {
        id: 'onboarding.screening.standalone.non_us_resident.try_calm_body',
        defaultMessage: 'Start With 40% Off',
        description: 'Discount offer',
    },
    'onboarding.screening.standalone.non_us_resident.back_to_screening': {
        id: 'onboarding.screening.standalone.non_us_resident.back_to_screening',
        defaultMessage: 'Back To Screening',
        description:
            'Button text to return to the standalone mental health screening.',
    },
    'onboarding.screening.standalone.results.app_promo.calm.title': {
        id: 'onboarding.screening.standalone.results.app_promo.calm.title',
        defaultMessage: 'We recommend you use Calm',
        description:
            'Promotional text for the Calm app for users who have completed the standalone mental health screening.',
    },
    'onboarding.screening.standalone.results.app_promo.calm.description': {
        id: 'onboarding.screening.standalone.results.app_promo.calm.description',
        defaultMessage:
            'You showed up for yourself today by checking in on your mental health. We’re happy to offer you a 40% discount on your first year of Calm Premium, so you can continue your mental health journey with daily support from the #1 app for sleep, meditation and relaxation.',
        description:
            'Discount offer for the Calm app for users who have completed the standalone mental health screening.',
    },
    'onboarding.screening.standalone.results.app_promo.calm.caption': {
        id: 'onboarding.screening.standalone.results.app_promo.calm.caption',
        defaultMessage:
            'You might already have access to Calm as part of your employee benefits. Check with your employer’s HR benefits department.',
        description:
            'Prompt directing users to try to redeem a subscription to the Calm app through their employer.',
    },
    'onboarding.screening.standalone.results.app_promo.calm.cta': {
        id: 'onboarding.screening.standalone.results.app_promo.calm.cta',
        defaultMessage: 'Start With 40% Off',
        description:
            'Call to action for the Calm app for users who have completed the standalone mental health screening.',
    },
    'onboarding.screening.standalone.results.app_promo.calm.header_cta': {
        id: 'onboarding.screening.standalone.results.app_promo.calm.header_cta',
        defaultMessage: '40% off Calm',
        description: 'Header for call to action for a promotion',
    },
    'onboarding.screening.standalone.results.app_promo.calm_health.yellow.title':
        {
            id: 'onboarding.screening.standalone.results.app_promo.calm_health.yellow.title',
            defaultMessage:
                'We recommend you explore your six-month access to Calm Health.',
            description:
                'Recommendation for the Calm Health app for users who have completed the standalone mental health screening.',
        },
    'onboarding.screening.standalone.results.app_promo.calm_health.yellow.description':
        {
            id: 'onboarding.screening.standalone.results.app_promo.calm_health.yellow.description',
            defaultMessage:
                'Calm Health offers a personalized plan of digital programs to help you better understand your mental health and physical wellbeing. Our programs are created by licensed psychologists and narrated by the trusted voices of Calm. We’re happy to offer you six months of access to this preview version of Calm Health. After six months, your access to the Calm Health preview will end. Click the link to activate your account.',
            description:
                'Explanation of benefits of the Calm Health app for users who have completed the standalone mental health screening.',
        },
    'onboarding.screening.standalone.results.app_promo.calm_health.orange_red.title':
        {
            id: 'onboarding.screening.standalone.results.app_promo.calm_health.orange_red.title',
            defaultMessage:
                'We recommend working with a mental health care provider.',
            description:
                'Recommendation for users who receive a high anxiety or depression score on the mental health screening.',
        },
    'onboarding.screening.standalone.results.app_promo.calm_health.orange_red.description':
        {
            id: 'onboarding.screening.standalone.results.app_promo.calm_health.orange_red.description',
            defaultMessage:
                'When used in conjunction with your primary care provider (PCP) or a mental health care provider, Calm Health’s personalized plan of digital programs can assist in helping you to better understand your mental health and physical wellbeing. Our programs are created by licensed psychologists and narrated by the trusted voices of Calm. We’re happy to offer you six months of access to this preview version of Calm Health to be used together with care from your doctor or a mental health professional. After six months, your access to the Calm Health preview will end. Click the link to activate your account.',
            description:
                'Explanation of benefits of the Calm Health app for users for users who require other care in addition to it.',
        },
    'onboarding.screening.standalone.results.app_promo.calm_health.cta': {
        id: 'onboarding.screening.standalone.results.app_promo.calm_health.cta',
        defaultMessage: 'Sign up for Calm Health',
        description: 'Button text to sign up for the Calm Health app.',
    },
    'onboarding.screening.standalone.results.app_promo.calm_health.header_cta':
        {
            id: 'onboarding.screening.standalone.results.app_promo.calm_health.header_cta',
            defaultMessage: 'Try Calm Health for free',
            description:
                'Call to action for users to get started with the Calm Health app.',
        },
    'onboarding.screening.standalone.results.become_a_champion.title': {
        id: 'onboarding.screening.standalone.results.become_a_champion.title',
        defaultMessage: 'Be a mental health champion for your team!',
        description:
            'Call to action for users to promote mental health in their workplace.',
    },
    'onboarding.screening.standalone.results.become_a_champion.body': {
        id: 'onboarding.screening.standalone.results.become_a_champion.body',
        defaultMessage:
            'Find out how you can provide Calm to your organization.',
        description:
            'Call to action for users to promote mental health in their workplace.',
    },
    'onboarding.screening.standalone.results.become_a_champion.cta': {
        id: 'onboarding.screening.standalone.results.become_a_champion.cta',
        defaultMessage: 'Learn More',
        description:
            'Button text to learn more about promoting mental health in the workplace.',
    },
    'onboarding.screening.standalone.results.resources.yellow.title': {
        id: 'onboarding.screening.standalone.results.resources.yellow.title',
        defaultMessage: 'Mental Health Resources',
        description:
            'Header for other mental health resources for users who have completed the standalone mental health screening.',
    },
    'onboarding.screening.standalone.results.resources.yellow.subtitle': {
        id: 'onboarding.screening.standalone.results.resources.yellow.subtitle',
        defaultMessage:
            'If you’re looking for additional support, you may want to consider working with a therapist. There are many types of therapists, and lots of resources available to help you find one who suits your needs. Contact your health plan or healthcare provider to find therapists in your network. Additionally, below are a few trusted organizations that can help you start your search.',
        description:
            'Description of other mental health resources for users who have completed the standalone mental health screening.',
    },
    'onboarding.screening.standalone.results.resources.yellow.additional': {
        id: 'onboarding.screening.standalone.results.resources.yellow.additional',
        defaultMessage:
            ' If you’re experiencing a life-threatening emergency, please call 911 or the National Suicide Prevention Lifeline at 988 to get immediate help.',
        description:
            'Prompt for users who might require immediate help that Calm Health cannot provide.',
    },
    'onboarding.screening.standalone.results.resources.orange_red.title': {
        id: 'onboarding.screening.standalone.results.resources.orange_red.title',
        defaultMessage: 'Find Support',
        description: 'Button text for users to try to get more support.',
    },
    'onboarding.screening.standalone.results.resources.orange_red.subtitle': {
        id: 'onboarding.screening.standalone.results.resources.orange_red.subtitle',
        defaultMessage:
            'However you’re feeling, you’re not alone, and help is available. Consider reaching out to a mental health practitioner. There are many kinds of therapy, like individual, group, and even virtual sessions. Contact your health plan or healthcare provider to find one in your network. There are also local treatment facilities, support groups, and community-based organizations. Here are some places to start looking for additional support.',
        description:
            'Description to make users feel reassured in seeking help.',
    },
    'onboarding.screening.standalone.results.resources.orange_red.additional': {
        id: 'onboarding.screening.standalone.results.resources.orange_red.additional',
        defaultMessage:
            'If you’re experiencing a life-threatening emergency, please call 911 or the National Suicide Prevention Lifeline at 988 to get immediate help.',
        description:
            'Prompt for users who might require immediate help that Calm Health cannot provide.',
    },
    'onboarding.screening.standalone.results.resources.resource_1_title': {
        id: 'onboarding.screening.standalone.results.resources.resource_1_title',
        defaultMessage:
            'Substance Abuse and Mental Health Services Administration',
        description: 'The name of an organization in the US',
    },
    'onboarding.screening.standalone.results.resources.resource_2_title': {
        id: 'onboarding.screening.standalone.results.resources.resource_2_title',
        defaultMessage: 'Anxiety & Depression Association of America',
        description: 'The name of an organization in the US',
    },
    'onboarding.screening.standalone.results.resources.resource_3_title': {
        id: 'onboarding.screening.standalone.results.resources.resource_3_title',
        defaultMessage: 'National Alliance on Mental Illness',
        description: 'The name of an organization in the US',
    },
    'onboarding.screening.standalone.results.disclaimer': {
        id: 'onboarding.screening.standalone.results.disclaimer',
        defaultMessage:
            'This screening, and the use of Calm Health, is not intended to diagnose or treat depression, anxiety, or any other disease or condition. This screening, and the use of Calm Health, is not a substitute for care by a physician or other health care provider. Any questions that you may have regarding the results or  the diagnosis, care, or treatment of a medical condition should be directed to your physician or health care provider. Calm Health is a mental wellness product.',
        description: 'Disclaimer for the standalone mental health screening.',
    },
    'onboarding.cchd_step.title': {
        id: 'onboarding.cchd_step.title',
        defaultMessage: 'Consent is required to access Calm Health.',
        description:
            'Explanation of why the user needs to consent to access Calm Health.',
    },
    'onboarding.cchd_step.content': {
        id: 'onboarding.cchd_step.content',
        defaultMessage:
            'To receive the limited experience, you need to allow Calm Health to collect certain personal health data, when necessary.',
        description:
            'Explanation of the Consent to Collect Consumer Health Data step.',
    },
    'onboarding.concierge.plan.title': {
        id: 'onboarding.concierge.plan.title',
        defaultMessage: 'Care Plan',
        description: 'Title for the concierge care plan onboarding step.',
    },
    'onboarding.concierge.title': {
        id: 'onboarding.concierge.title',
        defaultMessage: 'Onboarding',
        description: 'Title for the concierge onboarding step.',
    },
});

export default onboardingMessages;
